<template>
  <section>
    <h2 class="headline">Ближайшие офисы на карте</h2>
    <v-container class="reviews" grid-list-xl>
      <Map
        style="width: 100%; height: 500px;"
        :coords="coords"
        :map_position="map_position"
      />
      <ShemaOrgPlaces :coords="coords" />
    </v-container>
  </section>
</template>
<script>

import { mapState } from 'vuex';

import ShemaOrgPlaces from "../../components/shemaorg/ShemaOrgPlaces.vue";
import Map from "../../components/Map.vue";

export default {
  name: "Offices",
  components: {
    Map,
    ShemaOrgPlaces,
  },
  computed: mapState({
    coords: (state) => state.LandingM.coords,
    map_position: (state) => state.LandingM.map_position,
  }),
};
</script>
